import { useInjected } from '@bubblydoo/angular-react'
import { useEffect, useState } from 'react'

import { switchMap, timer } from 'rxjs'

import { ResourceDescriptionApiService } from '@flowx/designer/shared/api/resource-description.api'
import { ApplicationResourceType } from '@flowx/designer/shared/entities/application.entity'
import { DEFAULT_SHOW_DELAY } from '@flowx/react-ui-toolkit'

/** A process node's description, read once the pointer has rested on the node; null otherwise. */
export function useHoveredNodeDescription(
  processResourceId: string | null,
  flowxUuid: string,
  hovering: boolean
): string | null {
  const api = useInjected(ResourceDescriptionApiService)
  const [description, setDescription] = useState<string | null>(null)

  useEffect(() => {
    setDescription(null)

    if (!hovering || !processResourceId) {
      return
    }

    // Read again on every hover, so a description saved in the documentation modal shows at once.
    const subscription = timer(DEFAULT_SHOW_DELAY)
      .pipe(
        switchMap(() =>
          api.getDescription(ApplicationResourceType.Process, processResourceId, {
            elementType: 'node',
            elementId: flowxUuid,
          })
        )
      )
      .subscribe({
        next: (stored) => setDescription(stored.description),
        // A failed read shows no tooltip, the same as a node without a description.
        error: () => setDescription(null),
      })

    return () => subscription.unsubscribe()
  }, [api, processResourceId, flowxUuid, hovering])

  return description
}
